module.exports = __webpack_public_path__ + "static/media/PM20.8913f834.JPG";